import { render, staticRenderFns } from "./HowXt.vue?vue&type=template&id=0b3f756b&scoped=true"
import script from "./HowXt.vue?vue&type=script&lang=ts"
export * from "./HowXt.vue?vue&type=script&lang=ts"
import style0 from "./HowXt.vue?vue&type=style&index=0&id=0b3f756b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3f756b",
  null
  
)

export default component.exports